import { useState, useEffect } from 'react';

import { reportError } from '@perpay-web/utils/errorHandlers';

export const useSessionStorage = (key, initialValue) => {
    const getStoredValue = () => {
        try {
            const storedValue = window.sessionStorage.getItem(key);
            return storedValue ? JSON.parse(storedValue) : initialValue;
        } catch (e) {
            reportError('Error retrieving value from window.sessionStorage', e);
            return initialValue;
        }
    };

    const [value, setValue] = useState(getStoredValue);

    useEffect(() => {
        try {
            window.sessionStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            reportError('Error setting window.sessionStorage', e);
        }
    }, [key, value]);

    const updateValue = (newValue) => {
        setValue((prevValue) => {
            const finalValue =
                typeof newValue === 'function' ? newValue(prevValue) : newValue;
            try {
                window.sessionStorage.setItem(key, JSON.stringify(finalValue));
            } catch (e) {
                reportError('Error updating window.sessionStorage', e);
            }
            return finalValue;
        });
    };

    return [value, updateValue];
};
